<div class="content-card filters">
  <div class="top">
    <div class="top__left">
      <span matTooltip="{{ 'Order.MassEditWorkerRealizationDateTooltip' | translate }}"
        [matTooltipDisabled]="isMassEditWorkerRealizationDateButtonEnabled()">
        <button mat-raised-button color="primary" [visibleWithPermissions]="['ChangeOrderItemWorkerRealizationDate']"
          [disabled]="!isMassEditWorkerRealizationDateButtonEnabled()" (click)="openMassEditWorkerRealizationDate()"
          matTooltip="{{ 'Order.MassEditWorkerRealizationDateTooltip' | translate }}"
          [matTooltipDisabled]="isMassEditWorkerRealizationDateButtonEnabled()">
          {{ 'Order.MassEditWorkerRealizationDateInfo' | translate }}
        </button>
      </span>
    </div>
    <div class="top__right">
      <div class="filter-button-container">
        <button (click)="resetFilters()" class="top__button top__button-clear">
          <mat-icon>close</mat-icon>
          {{ 'Reset' | translate }}
        </button>
        <button (click)="toggleFiltersPanel()" class="top__button top__button-filter" [matBadge]="filters.length"
          matBadgeSize="small" [matBadgeHidden]="!filters.length">
          <mat-icon>filter_alt</mat-icon>
          {{ 'Filter' | translate }}
        </button>
      </div>
    </div>
  </div>
  @if (areFiltersExpanded) {
  <app-list-filter></app-list-filter>
  }
</div>
<div class="content-card table-container">
  <div class="table-wrapper custom-table">
    <mat-table #table matSort matSortActive="LastName" matSortDirection="asc" matSortDisableClear
      [dataSource]="dataSource">
      <ng-container matColumnDef="select" [sticky]="screenService.isAboveMd$ | async">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox appearance="outline" (change)="$event ? masterToggle() : null"
            [checked]="dataSource.selection.hasValue() && isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !isAllSelected()" [matTooltip]="'SelectAll' | translate"
            matTooltipPosition="above">
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? dataSource.selection.toggle(row) : null"
            [checked]="dataSource.selection.isSelected(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="workerFullName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="LastName" class="hidden-sort">
          {{ 'Order.StartRealizationList.Worker' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a [routerLink]="['/profile/' + element.WorkerId]">{{ element.LastName }} {{ element.FirstName }} </a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="employerName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.StartRealizationList.Employer' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmployerName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="employerObjectName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.StartRealizationList.EmployerObject' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmployerObjectName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="positionExpectationName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.StartRealizationList.PositionExpectation' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.PositionExpectationName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="submissionDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.StartRealizationList.SubmissionDate' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.SubmissionDate | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.StartRealizationList.StartDate' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.StartDate | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="workerRealizationDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.StartRealizationList.WorkerRealizationDate' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>

        <mat-cell *matCellDef="let element">
          @if (element.WorkerRealizationDate) {
          <span>{{ element.WorkerRealizationDate | date : 'yyyy-MM-dd' }}</span>
          }

          @if (isPossibleToEdit(element) && hasPermissionToChangeWorkerRealizationDate()) {
          <div class="datepicker-container" #datePickerContainer>
            <input matInput [matDatepicker]="picker" [formControl]="dateControl" [min]="element.StartDate"
              [max]="maxDate" class="datepicker-input" />
            <mat-datepicker-toggle [for]="picker" (click)="startEdit(element)">
              <mat-icon matDatepickerToggleIcon color="primary">event</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker>
              <mat-datepicker-actions>
                <button mat-button matDatepickerCancel (click)="finishEditing()">
                  {{ 'Cancel' | translate }}
                </button>
                <button mat-raised-button color="primary" matDatepickerApply (click)="saveDate(element)">
                  {{ 'Save' | translate }}
                </button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </div>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions" stickyEnd>
        <mat-header-cell *matHeaderCellDef> {{ 'Actions' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <ng-container></ng-container>

          @if (screenService.isAboveMd$ | async) {
          @if (hasAnyAction(element)) {
          <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
            <mat-icon class="material-icons-outlined">more_vert</mat-icon>
          </button>
          }
          } @else {
          @if (hasAnyAction(element)) {
          <button mat-icon-button [matMenuTriggerFor]="menuRow">
            <mat-icon class="material-icons-outlined">more_vert</mat-icon>
          </button>
          }
          }


          <mat-menu #menuRow="matMenu" panelClass="actions-menu">
            <ng-container>
              @if (clearWorkerRealizationDateButtonVisible(element)) {
              <button mat-button (click)="cleanWorkerRealizationDate(element.WorkerOrderItemId)">
                <mat-icon>delete</mat-icon>
                <span class="button-text">{{ 'Order.StartRealizationList.Delete' | translate }}</span>
              </button>
              }
            </ng-container>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
</div>

<mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"></mat-paginator>